import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useCurrency } from "../../Context/CurrencyContext";
import SizeChartModal from "../SizeChartModal/SizeChartModal";
import "./ProductModal.css";

export default function ProductModal({ item, onClose }) {
  const [activeImage, setActiveImage] = useState(0);
  const [selectedSize, setSelectedSize] = useState(null);
  const [sizeError, setSizeError] = useState(false);
  const [showSizeChart, setShowSizeChart] = useState(false);
  const { getPrice } = useCurrency();
  const navigate = useNavigate();

  useEffect(() => {
    setActiveImage(0);
    setSelectedSize(null);
    setSizeError(false);
    setShowSizeChart(false);
  }, [item]);

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === "Escape") onClose();
    }
    document.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "auto";
    };
  }, [onClose]);

  if (!item) return null;

  const images = item.images?.length > 0 ? item.images : [item.imageUrl];

  const handleBuyNow = () => {
    if (item.sizes?.length > 0 && !selectedSize) {
      setSizeError(true);
      return;
    }
    navigate("/checkout", { state: { item, size: selectedSize } });
  };

  return (
    <div className="product-modal-overlay" onClick={onClose}>
      <div className="product-modal" onClick={(e) => e.stopPropagation()}>
        <button
          className="modal-close-btn"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>

        <div className="modal-gallery">
          <div className="modal-main-image">
            <img src={images[activeImage]} alt={item.name} />
          </div>
          {images.length > 1 && (
            <div className="modal-thumbnails">
              {images.map((src, idx) => (
                <img
                  key={src}
                  src={src}
                  alt={`${item.name} ${idx + 1}`}
                  className={idx === activeImage ? "active" : ""}
                  onClick={() => setActiveImage(idx)}
                />
              ))}
            </div>
          )}
        </div>

        <div className="modal-details">
          <h2>{item.name}</h2>
          <p className="modal-price">{getPrice(item)}</p>
          <p className="modal-desc">{item.description}</p>

          {item.sizes?.length > 0 && (
            <div className="modal-sizes">
              <div className="modal-sizes-header">
                <span className="modal-sizes-label">Select Size</span>
                <button
                  type="button"
                  className="size-chart-hint"
                  onClick={() => setShowSizeChart(true)}
                >
                  Not sure of your size? View size chart
                </button>
              </div>
              <div className="size-options">
                {item.sizes.map((size) => (
                  <button
                    key={size}
                    className={`size-btn ${selectedSize === size ? "selected" : ""}`}
                    onClick={() => {
                      setSelectedSize(size);
                      setSizeError(false);
                    }}
                  >
                    {size}
                  </button>
                ))}
              </div>
              {sizeError && (
                <p className="size-error">
                  Please select a size. Unsure which one?{" "}
                  <button
                    type="button"
                    className="size-chart-hint size-chart-hint--inline"
                    onClick={() => setShowSizeChart(true)}
                  >
                    Check the size chart
                  </button>
                  .
                </p>
              )}
            </div>
          )}

          <button className="buy-btn modal-buy-btn" onClick={handleBuyNow}>
            Buy Now
          </button>
        </div>
      </div>

      {showSizeChart && (
        <SizeChartModal
          onClose={() => setShowSizeChart(false)}
          highlightSize={selectedSize}
        />
      )}
    </div>
  );
}
